import React from 'react'
import PropTypes from 'prop-types'
import { Container, VipHeadline, Title, Deal } from './styles'

const DiscountBanner = ({ max }) => (
  <Container>
    <VipHeadline>BACK-TO-SCHOOL SALE:</VipHeadline>
    <Title>$40 Off Calendar {max ? 'Max' : ''}</Title>
    <Deal>
      Discount automatically applied at checkout. Ends 8/11 at 11:59pm PST or while supplies last.
    </Deal>
  </Container>
)

export default DiscountBanner

DiscountBanner.propTypes = {
  max: PropTypes.bool,
}
